import { hysteriFetch, wrappers } from 'hysterics';
import logger from 'ws-scripts/modules/logger';

const gvClientFetcher = hysteriFetch('global-vehicle.rest-v2.client');

export const API = {
	getGvModels: async (models, make, accountId, locale, options) => {
		const fetchHeaders = new Headers();
		fetchHeaders.append('pragma', 'cache');
		fetchHeaders.append('cache-control', 'cache');
		fetchHeaders.append('Accept', 'application/json');
		fetchHeaders.append('Content-Type', 'application/json');

		try {
			const modelsFetch = await gvClientFetcher(
				'/api/widget/ws-car-customizer/gvTrimsForModels',
				{
					method: 'POST',
					headers: fetchHeaders,
					body: JSON.stringify({
						models,
						make,
						accountId,
						locale,
						options
					}),
					timeout: 3000
				},
				{
					[wrappers.timeout.contextKey]: {
						timeout: 3000
					},
					[wrappers.retry.contextKey]: {
						retries: 1
					}
				}
			);
			return modelsFetch;
		} catch (err) {
			const errorText = `Error retrieving models: ${err.message}`;
			logger.error(errorText);
			return errorText;
		}
	},
	getGvTrims: async (trimId, accountId, locale, options) => {
		const fetchHeaders = new Headers();
		fetchHeaders.append('pragma', 'cache');
		fetchHeaders.append('cache-control', 'cache');
		fetchHeaders.append('Accept', 'application/json');
		fetchHeaders.append('Content-Type', 'application/json');

		try {
			const trimFetch = await gvClientFetcher(
				'/api/widget/ws-car-customizer/byTrimId',
				{
					method: 'POST',
					headers: fetchHeaders,
					body: JSON.stringify({
						trimId,
						accountId,
						locale,
						options
					}),
					timeout: 3000
				},
				{
					[wrappers.timeout.contextKey]: {
						timeout: 3000
					},
					[wrappers.retry.contextKey]: {
						retries: 1
					}
				}
			);
			return trimFetch;
		} catch (err) {
			const errorText = `Error retrieving trims: ${err.message}`;
			logger.error(errorText);
			return errorText;
		}
	},
	getGVShowroomVehicle: async (
		globalVehicleId,
		accountId,
		locale,
		options
	) => {
		const fetchHeaders = new Headers();
		fetchHeaders.append('pragma', 'cache');
		fetchHeaders.append('cache-control', 'cache');
		fetchHeaders.append('Accept', 'application/json');
		fetchHeaders.append('Content-Type', 'application/json');

		try {
			const showroomVehicleFetch = await gvClientFetcher(
				'/api/widget/ws-car-customizer/byShowroomVehicle',
				{
					method: 'POST',
					headers: fetchHeaders,
					body: JSON.stringify({
						globalVehicleId,
						accountId,
						locale,
						options
					}),
					timeout: 3000
				},
				{
					[wrappers.timeout.contextKey]: {
						timeout: 3000
					},
					[wrappers.retry.contextKey]: {
						retries: 1
					}
				}
			);
			return showroomVehicleFetch;
		} catch (err) {
			const errorText = `Error retrieving trims from byShowroomVehicle: ${err.message}`;
			logger.error(errorText);
			return errorText;
		}
	}
};
